import React, {useEffect, useState} from 'react';
import { Navigate, useParams, useNavigate } from "react-router-dom";
import Loader from '../../components/Loader';
import { useUser, isAdmin, isAgent } from '../../contexts/UserContext';
import { dateFromTimestampToString } from '../../librairies/Dates';
import {useFirestoreCollection} from '../../librairies/Firestore';
import DataTable from '../table/Datatable';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import AddItem from '../actions/AddItem';
import ToggleActivationLink from '../actions/ToggleActivationLink';
import { couleurEtatComposant } from './EtatComposant';
import TextModal from '../../components/modals/TextModal';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const Composants = () => {

  const { client_id, site_id, silo_id, machine_id } = useParams(); // Capture l'ID du client depuis l'URL
  const { data: composants, loader } = useFirestoreCollection(`clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines/${machine_id}/composants`);
  const [ajoutComposant, popupAjoutComposant] = useState(false);
  const [rapportMaintenance, popupRapportMaintenance] = useState(false);
  const [machine, setMachine] = useState(null);
  const [spec, setSpec] = useState("");
  const navigate = useNavigate();

  //contexte de l'utilisateur connecté
  const user = useUser();

  useEffect(() =>{
    getMachine(); 
  }, []);

  const getMachine = async () => {
    const documentRef = doc(db, `clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines/${machine_id}`);
    
    // Récupérer le document depuis Firestore
    const docSnap = await getDoc(documentRef);

    // Vérifiez si le document existe
    if (docSnap.exists()) {
      const data = docSnap.data();
      setMachine(data);
    } else {
      console.log("Aucun document trouvé !");
    }
  }

  const formattedText = (
    <>
      {`Vous êtes sur le point de commencer la maintenance d'une machine, veillez à vous assurer d'être en sécurité :
        - Consignation électrique de la machine ✅
        - Port des EPI ✅
        - Travail en hauteur = Port du harnais de sécurité ! ✅
        - Coactivité ❌
        - Travailleur isolé ❌
        
        Mon équipe est en sécurité -->`
        .split('\n')
        .map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
    </>
  );

  const columns = [
    { header: 'Nom', render: (composant) => composant.nom },
    { header: 'État', render: (composant) => (
      <div className="flex items-center">
        <span
          className={`inline-block w-2.5 h-2.5 rounded-full mr-2 ${
            couleurEtatComposant(composant.etat)
          }`}
        ></span>
        {composant.etat}
      </div>
    )},
    { header: 'Action', render: (composant) => (
      <div className='flex gap-4'>
        <ToggleActivationLink collection={`clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines/${machine_id}/composants`} item={composant} />
        {composant.spec ? (
          <a
            onClick={(e) =>setSpec(composant.spec)}
            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          >
            Spec
          </a>
        ) : null }
      </div>
    )}
  ];

  return (
    <div>
      {machine !== null ? (
        <p className='text-xl font-bold text-center p-4'>{machine.nom}</p>
      ) : null}
      
      {isAdmin(user.user) ? (
        <a href="#" onClick={() => popupAjoutComposant(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Ajouter un composant"} loading={false} />
        </a>
      ) : null }

      {isAgent(user.user) && (machine !== null && machine.dateMaintenance == undefined) ? (
        <a href="#" onClick={() => popupRapportMaintenance(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Mode maintenance"} loading={false} />
        </a>
      ) : null }

      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={composants} 
          columns={columns} 
          onRowClick={(composant) => console.log(composant)}
        />
      )}

      {ajoutComposant ? (
        <AddItem
          onClose={() => popupAjoutComposant(false)}
          collectionPath={`clients/${client_id}/sites/${site_id}/silos/${silo_id}/machines/${machine_id}/composants`}
          title="Ajouter un composant"
          fields={[
            { name: "nom", label: "Nom du composant", type: "text" },
          ]}
        />
      ) : null }

      {rapportMaintenance ? (
        <TextModal onClose={() => popupRapportMaintenance(false)} title="⚠️ ALERTE DE SÉCURITÉ ⚠️" 
          text={formattedText}
          button={{'name':'Commencer la maintenance', 'action':() => navigate(`/mode-maintenance/${client_id}/${site_id}/${silo_id}/${machine_id}`, { replace: true })}}/>
      ) : null }

      {spec != "" ? (
        <TextModal onClose={() => setSpec("")} title="Spec" 
          text={spec} />
      ) : null }
    </div>
  );
};

export default Composants;
